import React from 'react';
import styled, {useTheme} from 'styled-components';
import classNames from "classnames";
import {useBoundStore} from "../../stores/useBoundStore";

const Holder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  font-family: ${(props) => props.fontFamily};
  pointer-events: none;
  display: flex;
  
  &.center {
    align-items: center;
    justify-content: center;
    p {
      text-align: center;
    }
  }

  &.left {
    align-items: flex-start;
    justify-content: flex-start;
    p {
      text-align: left;
    }
  }
  
  &.right {
    align-items: flex-end;
    justify-content: flex-end;
    p {
      text-align: right;
    }
  }
  
  .text-wrapper {
    padding: 2rem;
  }
  
  &.hasBg {
    .text-wrapper {
      background-color: var(--textBGColor);
    }
  }

  p {
    margin: 0;
    line-height: 1.2;
    color: var(--textColor);
    font-weight: bold;
  }

  p:first-child {
    ${(props) => props.theme.fluidType(5)};
  }

  p:last-child {
    ${(props) => props.theme.fluidType(2)};
  }
`;

function TextHolder({children, propName}) {
  const textTop = useBoundStore((state) => state.textTop);
  const textBottom = useBoundStore((state) => state.textBottom);
  const textColor = useBoundStore((state) => state.textColor);
  const textBGColor = useBoundStore((state) => state.textBGColor);
  const textBGActive = useBoundStore((state) => state.textBGActive);
  const fontFamily = useBoundStore((state) => state.fontFamily);
  const textPosition = useBoundStore((state) => state.textPosition);
  const theme = useTheme();

  const textClasses = classNames( textPosition.toLowerCase(), {
    "hasBg": textBGActive,
  })
  return (
    <Holder
      fontFamily={fontFamily}
      className={textClasses}
      style={{
        "--textColor": theme.colors[textColor],
        "--textBGColor": theme.colors[textBGColor],
      }}
    >
      <div className="text-wrapper">
        <p>{textTop}</p>
        <p>{textBottom}</p>
      </div>
    </Holder>
  )
}

export default TextHolder;
